import moment, { Moment } from 'moment';

export const validDate = (date: string | Date | undefined): Moment | null | '' => {
  if (date) {
    const d = moment(date);
    return d.isValid() ? d : null;
  }
  return '';
};
